export function removeVnodeCache(self) {
    if (self.$vnode && self.$vnode.data.keepAlive) {
        if (self.$vnode.parent && self.$vnode.parent.componentInstance && self.$vnode.parent.componentInstance.cache) {
            if (self.$vnode.componentOptions) {
                var key = self.$vnode.key == null
                    ? self.$vnode.componentOptions.Ctor.cid + (self.$vnode.componentOptions.tag ? `::${self.$vnode.componentOptions.tag}` : '')
                    : self.$vnode.key;
                var cache = self.$vnode.parent.componentInstance.cache;
                var keys = self.$vnode.parent.componentInstance.keys;
                if (cache[key]) {
                    if (keys.length) {
                        var index = keys.indexOf(key);
                        if (index > -1) {
                            keys.splice(index, 1);
                        }
                    }
                    delete cache[key];
                }
            }
        }
    }
    self.$destroy();
}

/***
 * 清除绑定的事件
 */
function clearEventBusBind(self){
    if(typeof(self.clearEventBusBind)==='function'){
        self.clearEventBusBind();
    }
}


// export const globalMixin = {
//     beforeRouteLeave (to, from, next) {
//         // 导航离开该组件的对应路由时调用
//         // 可以访问组件实例 `this`
//         let self:any = this;
//         let toLen = to.matched.length;
//         if(to.meta.keepAlive){
//             let toCompName = to.matched[toLen-1].components.default.name;
//             self.$store.commit("app/addKeepAliveComp",toCompName);
//         }
//
//         if(from.meta.keepAlive){
//             let fromLen = from.matched.length;
//             let fromComp = from.matched[fromLen-1].components.default.name;
//             if(from.meta.keepAliveRoutes){
//                 if(!_.find(from.meta.keepAliveRoutes, o=>{return o==to.name})){
//                     self.$store.commit("app/removeKeepAliveComp",fromComp);
//                 }
//             }
//         }
//
//
//         next();
//     },
// }
// let oldVue = null;
// let cIndex = 0;

export const globalMixin = {
    beforeRouteLeave(to, from, next) {
        // 导航离开该组件的对应路由时调用
        // 可以访问组件实例 `this`
        let self: any = this;
        if (!from.meta.keepAlive) {
            removeVnodeCache(self);
        } else {
            // if(to.name === from.name){
            //     removeVnodeCache(self);
            //     return next();
            // }
            let keepAliveRoutes = from.meta.keepAliveRoutes;
            if (keepAliveRoutes && keepAliveRoutes.length > 0) {
                let targetName = to.name;
                if (!_.find(keepAliveRoutes, (o) => o == targetName)) {
                    removeVnodeCache(self);
                }
            }
        }
        next();
    },
    // beforeRouteUpdate (to, from, next) {
    //     let self:any = this;
    //     if(to.name === from.name && cIndex==1){
    //         next({path:'/redirect'});
    //     }else{
    //         next();
    //     }
    //     cIndex++;
    // },

    beforeDestroy(){
        clearEventBusBind(this);
    }
}
